// @ts-check

/** @typedef {import("./game_lists/GameList.js").GameListType} GameListType */
/** @typedef {import("./index.js").BuildConfiguration} BuildConfiguration */
import { DEV_URL } from "./Constants.js";
import { ReturnFrontendParametersString, checkIfMobile } from "./Parameters.js";
import { findGame } from "./Utils.js";
import { captureSampleError } from "./Sentry.js";
import { isCorrectStageValue } from "./game_lists/GameList.js";

/**
 * @typedef {Object} BuildUrls
 * @property {string=} development
 * @property {string} online
 * @property {string} onlineSelective
 * @property {string} e2Web
 * @property {string} e2Mobile
 */
// type BuildUrls = {
//     development?: string;
//     online: string;
//     onlineSelective: string;
//     e2Web: string;
//     e2Mobile: string;
// };

/** 
 * @type {Readonly<BuildUrls>} 
*/
const buildUrlsDev = {
    development: DEV_URL + "builds/engin3/development/web/latest/",
    online: DEV_URL + "online/",
    onlineSelective: DEV_URL + "onlineSelective/",
    e2Web: "https://gs-client.testowaplatforma123.net/online/development/demo/single_run/game.html",
    e2Mobile: "https://gs-client.testowaplatforma123.net/online/development/demo_mobile/single_run/game.html",
};

export const noStageError = new Error("No stage param has been set.");
export const nullValueForStageInGameConfigError = new Error("The game config exists in the gamelist, but the value for currently selected stage is set to null.")
export const customBuildOnProductionError = new Error("You are trying to use the game, that has customBuild set in their configuration, on production environment, either update configuration (probably what you need to do) or update uiUrl (make sure you know what you do).")
export const frozenBuildUnsetError = new Error('The stage value in game config is set to "freeze" but there is no "frozenBuild" set. It should never happen. Either tests are broken or someone/something pushed code to production without running tests.')
/**
 * 
 * @param {URL} url 
 * @param {GameListType} gameList 
 * @param {BuildConfiguration} buildConfiguration 
 * @returns {string}
 */
export function redirectUrl(url, gameList, buildConfiguration) {
    console.log(url, "url")

    //awful hack for old gs, TODO: delete when backend updates gs on frozen envs
    //hack for old gs, check tests
    if (url.searchParams.get("stage") && url.searchParams.get("stage")?.split("?").length === 2 && ["staging", "stage1", "stage2", "stage3", "stage4"].includes(/** @type {string} */(url.searchParams.get("stage")).split("?")[0])) {
        captureSampleError("Old gs hack - stage", 0.01);
        return url.origin + url.pathname + "?" + url.search.replace("?", "").replace("?", "&");
    }

    //second hack for old gs, check tests, please let me out
    if (url.searchParams.get("hackRulesMaxWinningsCap")?.split("?").length === 2 && url.searchParams.get("hackRulesMaxWinningsCap")?.split("?")[0] === "true") {
        captureSampleError("Old gs hack - hackRulesMaxWinningsCap", 0.01);
        return url.origin + url.pathname + "?" + url.search.replace("?", "").replace("?", "&");
    }

    //third hack for old gs, check tests, please let me out
    if (url.searchParams.get("showMaxHourlyLossRules")?.split("?").length === 2 && url.searchParams.get("showMaxHourlyLossRules")?.split("?")[0] === "true") {
        captureSampleError("Old gs hack - showMaxHourlyLossRules", 0.01);
        return url.origin + url.pathname + "?" + url.search.replace("?", "").replace("?", "&");
    }


    //generally awful hack for new jackpots, will be deleted later, when we fix jackpots on backend too
    if (url.searchParams.get("gameUrl")) { //https://beefee.slack.com/archives/C05FDRJ2878/p1700041158277549
        return hackRedirectWhenJackpotsEnabled(url)
    }

    const gameId = url.searchParams.get("gameId")
    if (!gameId) {
        throw new Error("URL is missing gameId param");
    }
    let game = findGame(gameId, gameList);

    //FIXME: refactor this, only 1 game uses that, it's overcomplicated system that was a result of my mistake in the past
    const brandedGameVersion = findGame(url.searchParams.get("gameId") + "-" + url.searchParams.get("operatorId"), gameList);
    if (url.searchParams.get("addOperatorIdToGameId") === "true" && brandedGameVersion) {
        url.searchParams.set("gameId", brandedGameVersion.id)
        game = brandedGameVersion
    }

    if (!game) {
        throw new Error("Game not added to gamelist: " + url.searchParams.get("gameId"));
    }


    const stageParam = url.searchParams.get("stage");
    const forceCustomBuildParam = url.searchParams.get("forceCustomBuild");

    if (!stageParam) {
        throw noStageError;
    }

    if (game.customBuild && stageParam != "development") {
        throw customBuildOnProductionError;
    }

    if (!isCorrectStageValue(stageParam)) {
        throw new Error("unallowed value for stage param: " + stageParam)
    }

    /** @type {BuildUrls} */
    let buildOrigin;
    if (url.href.includes(DEV_URL) || /** @type {string} */ (stageParam) === "development") {
        buildOrigin = buildUrlsDev;
    } else {
        buildOrigin = {
            online: url.origin + "/online/",
            onlineSelective: url.origin + "/onlineSelective/",
            e2Web: "https://static-prod.beefee.co.uk/e2-web/single_run/game.html",
            e2Mobile: "https://static-prod.beefee.co.uk/e2-mobile/single_run/game.html",
        };
    }

    let buildType = game[stageParam]
    if (buildType === "freeze" && !game.frozenBuild) {
        throw frozenBuildUnsetError;
    }
    
    //overwrite path to development with e2 if this is an e2 game, TODO: DELETE ONCE E2 IS NO LONGER USED
    if (game["staging"] === "e2" && /** @type {string} */ (stageParam) === "development") {
        buildType = "e2"
    }

    console.log(buildOrigin, buildType)

    const inputParams = url.search;
    console.log("input url params:\n", inputParams);
    let outputParams = ReturnFrontendParametersString(url.searchParams, buildType === "e2" ? "e2" : "e3", gameList);
    console.log("output url params:\n", outputParams);

    let newUrl = "";
    if (buildType === "online" || buildType === "onlineSelective") {
        const buildNumber = buildConfiguration[buildType][stageParam]
        newUrl = buildOrigin[buildType] + buildNumber + "/";
    } else if (buildType === "e2") {
        newUrl = checkIfMobile() ? buildOrigin.e2Mobile : buildOrigin.e2Web;
    } else if (/** @type {string} */ (stageParam) === "development" || buildType === "development") {
        newUrl = /** @type {string} */ (buildUrlsDev.development);
    } else if (buildType === "freeze") {
        newUrl =  /** @type {string} */ (game.frozenBuild);
    } else {
        throw nullValueForStageInGameConfigError;
    }

    if (forceCustomBuildParam) {
        console.warn("[url.forceCustomBuild] Overwriting build path URL with: ", forceCustomBuildParam)
        newUrl = forceCustomBuildParam;
    }
    if (game.customBuild) {
        console.warn("[gameConfig.customBuild] Overwriting build path URL with: ", game.customBuild)
        newUrl = game.customBuild;
    }
    newUrl += "?" + outputParams;
    console.log("Returning URL: ", newUrl)
    return newUrl;
}

/**
 * 
 * @param {URL} url 
 * @returns {string}
 */
function hackRedirectWhenJackpotsEnabled(url) {
    console.log(url.searchParams.get("sessionId"), "SESSION ID")
    const rules = url.searchParams.get("jackpotRulesTemplateUrl")
    const rulesUrl = url.searchParams.get("jackpotRulesUrl")
    const extraRulesUrl = url.searchParams.get("jackpotExtraRulesUrl")
    const gameUrl = url.searchParams.get("gameUrl")
    const updateUrl = url.searchParams.get("updateUrl")
    if (!gameUrl) throw new Error("missing gameUrl parameter")
    if (!updateUrl) {
        //I'm pretty sure it should always be present, but to confirm that send error on Sentry if it's not
        captureSampleError("(WebJackpots issue) there is no updateUrl when gameUrl is present", 1)
    }
    return atob(gameUrl) + "&jackpotRulesTemplateUrl=" + rules + "&jackpotRulesUrl=" + rulesUrl + "&jackpotExtraRulesUrl=" + extraRulesUrl + "&updateUrl=" + updateUrl;
}